/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryRunActionRequest {
    getFixupPrototypeFunction() { return InventoryRunActionRequest.fixupPrototype; }

    static newInstance(model: Partial<InventoryRunActionRequest>): InventoryRunActionRequest {
        let obj = Object.assign(new InventoryRunActionRequest(), model);
        InventoryRunActionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryRunActionRequest>): InventoryRunActionRequest {
        if (!model) return null;
        return InventoryRunActionRequest.newInstance(<InventoryRunActionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryRunActionRequest) {
        if (!obj) return;

        models.InventoryRunActionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryRunActionRequest): boolean {
        Object.setPrototypeOf(obj, InventoryRunActionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identifier of the inventory record the action runs against, as returned by the list endpoint
     */
    resource_id: string;

    /**
     * Swagger action to run, as the actions catalog publishes it for the record's type, for example StopInstances. Its inputs are read from the record
     */
    operation_id: string;

}
